export default "__VITE_ASSET__CYimuIKM__"